
import { Component, Vue,Inject } from 'vue-property-decorator';
import Footer from '../components/Footer.vue'
import TenantSwitch from '../components/tenant-switch.vue'
import LanguageSwitch from '../components/language-switch.vue'
import AbpBase from '../lib/abpbase'
@Component({
 components:{Footer,TenantSwitch,LanguageSwitch}
})
export default class Login extends AbpBase {
 loginModel={
   userNameOrEmailAddress:'',
   password:'',
   rememberMe:false,
   userType:1,
   googleCode:''
 }
 showChangeTenant:boolean=false
 regist(){
  this.$router.push({
    name:'register'
  })
 }
 async login(){
   if (!this.loginModel.userNameOrEmailAddress) {
     this.$Notice.error({ title: '请输入账号' })
     return
   }
   if (!this.loginModel.password) {
     this.$Notice.error({ title: '请输入密码' })
     return
   }
   this.$Message.loading({
     content: this.L('LoginPrompt'),
     duration: 0
   })
   await this.$store.dispatch({
     type: 'app/login',
     data: this.loginModel
   })
   sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '0');
   location.reload();
 }
 get tenant(){
   return this.$store.state.session.tenant;
 }
 rules={
   userNameOrEmailAddress: [
     { required: true, message: this.L('UserNameRequired'), trigger: 'blur' }
   ],
   password: [
     { required: true, message: this.L('PasswordRequired'), trigger: 'blur' }
   ]
 }
 created(){
 }
}
